import { Controller } from "@hotwired/stimulus";

const HIDDEN_CLASS = "hidden";
const ACTIVE_DOT_ATTRIBUTE = "data-active";

export default class extends Controller {
  static targets = ["previewItem", "goToButton"];

  previousItem() {
    const activeItemIndex = this.#activeItemIndex();
    this.#setActiveItem(activeItemIndex, activeItemIndex - 1);
  }

  nextItem() {
    const activeItemIndex = this.#activeItemIndex();
    this.#setActiveItem(activeItemIndex, activeItemIndex + 1);
  }

  goToItem(e) {
    let { target } = e;
    let index = null;
    while (index === null) {
      if ("index" in target.dataset) {
        index = +target.dataset.index;
      } else {
        target = target.parentNode;
      }
    }
    this.#setActiveItem(this.#activeItemIndex(), index);
  }

  #activeItemIndex() {
    return this.previewItemTargets.findIndex((el) => !el.classList.contains(HIDDEN_CLASS));
  }

  #setActiveItem(currentActiveIndex, newActiveIndex) {
    const currentActiveItem = this.previewItemTargets[currentActiveIndex];
    const newActiveItem = this.previewItemTargets[newActiveIndex];

    if (currentActiveItem && newActiveItem) {
      currentActiveItem.classList.add(HIDDEN_CLASS);
      newActiveItem.classList.remove(HIDDEN_CLASS);
      this.#toggleDot(this.goToButtonTargets[currentActiveIndex], false);
      this.#toggleDot(this.goToButtonTargets[newActiveIndex], true);
    }
  }

  #toggleDot(dot, active) {
    dot?.toggleAttribute(ACTIVE_DOT_ATTRIBUTE, active);
  }
}
